import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { MultiSelect } from "react-multi-select-component";
import * as moment from 'moment';
import close from '../Asset/close.svg';
import Table from './tables/operatorTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Tabs, Tab, Form, Modal } from 'react-bootstrap';
import Alert from './Alert';
import { getUserInfo, getDashboard } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Operator() {
  const dashboard = sessionStorage.getItem('Dashboards') ? getDashboard() : [];
  let userObj = getUserInfo();
  let today = moment().format('YYYY-MM-DD');
  let [sessOut, setSessOut] = useState(false);
  let [operator, setOperator] = useState({ //2022-02-24T04:39:12.9633333+00:00
    operatorName: "",
    operatorID: "",
    licenceID: "",
    licenceExpiryDate: "",
    licenceValdity: "",
    isActive: true,
    assetID: "",
    shiftID: []
  });
  let [years, setYears] = useState([]);
  let [filterShow, setFilterShow] = useState(false);
  let [siteList, setSiteList] = useState([]);
  let [allAseet, setAllAsset] = useState([]);
  let [cate, setCate] = useState([]);
  let [subCate, setSubCate] = useState([]);
  let [dropdownData, setDropDownData] = useState({
    asset_equipmentType: [
      { name: "" },
    ]
  });
  let defaultFilter = {
    year: "",
    month: "",
    toDate: moment().format('YYYY-MM-DD'),
    fromDate: moment().format('YYYY-MM-DD'),
    equipmentID: "",
    equipmentType: "",
    siteID: "",
    productCategoryID: "",
    productSubCategoryID: ""
  }
  let [filter, setFilter] = useState({
    year: "",
    month: "",
    toDate: moment().format('YYYY-MM-DD'),
    fromDate: moment().format('YYYY-MM-DD'),
    equipmentID: "",
    equipmentType: "",
    siteID: "",
    productCategoryID: "",
    productSubCategoryID: ""
  });

  useEffect(() => {
    let globObj = JSON.parse(sessionStorage.getItem('GloberFilter'));
    let abortController = new AbortController();
    let todate = new Date();
    let tempy = [];
    var dd = String(todate.getDate()).padStart(2, '0');
    var mm = String(todate.getMonth() + 1).padStart(2, '0');
    var yyyy = todate.getFullYear();
    for (let i = 0; i < 3; i++) {
      tempy.push(yyyy - i);
    }
    if (globObj && globObj != 'undefined') {
      var flag = false, filObj;
      flag = checkDurFilter(globObj);
      filObj = flag ? globObj : {
        equipmentID: globObj.equipmentID,
        productCategoryID: globObj.productCategoryID,
        productSubCategoryID: globObj.productSubCategoryID,
        equipmentType: globObj.equipmentType,
        siteID: globObj.siteID,
        year: globObj.year,
        month: globObj.month,
        fromDate: yyyy + "-" + mm + "-" + dd,
        toDate: yyyy + "-" + mm + "-" + dd,
      }
      setFilter(filObj);
      getoperatorImpactData(filObj);
      globObj.productCategoryID != "" ? getProductSubCategory(parseInt(globObj.productCategoryID)) : false;
    }
    else {
      getoperatorImpactData({ fromDate: today, toDate: today });
    }
    setYears(tempy);
    getEquipmentByUser();
    getShiftForOpoerator();
    getOperatorByAcc();
    getProductCategory();
    getDropDown();
    getSiteList();

    return () => {
      abortController.abort();
    }
  }, [])

  const valueRenderer = (selected) => {
    let label = [];
    selected.map((item) =>
      label.push(item.label)
    )
    if (selected.length === 0) {
      return "Select"
    }
    else {
      return label.toString();
    }
  };

  function resetFilter() {
    sessionStorage.removeItem('GloberFilter');
    setFilter(defaultFilter);
    getoperatorImpactData(defaultFilter)
  }
  function ResetForm() {
    setOperatorShift1([])
    setOperatorErrorMsg({});
    setOperator({
      operatorName: "",
      operatorID: "",
      licenceID: "",
      licenceExpiryDate: "",
      licenceValdity: "",
      isActive: true,
      assetID: "",
      shiftID: []
    });

  }

  function getFilterData(e) {
    if (e.target.name == "fromDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "toDate") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", year: "" });
    }
    else if (e.target.name == "month") {
      setFilter({ ...filter, [e.target.name]: e.target.value, year: "", fromDate: "", toDate: "" });
    }
    else if (e.target.name == "year") {
      setFilter({ ...filter, [e.target.name]: e.target.value, month: "", fromDate: "", toDate: "" });
    }
    else if (e.target.name === "productCategoryID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      getProductSubCategory(parseInt(e.target.value));
    }
    else if (e.target.name === "productSubCategoryID" || e.target.name === "siteID") {
      setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
      if (e.target.name === "siteID") {
        getEquipmentBySite(e.target.value);
      }
    }
    else {
      setFilter({ ...filter, [e.target.name]: e.target.value });
    }
  }
  function getFilterFields() {
    getoperatorImpactData(filter)
  }
  function getFormData(e) {
    if (e.target.name == "licenceValdity") {
      setOperator({ ...operator, [e.target.name]: e.target.value, licenceExpiryDate: e.target.value });
    }
    else {
      setOperator({ ...operator, [e.target.name]: e.target.value });
    }

  }
  let [malert, setAlert] = useState({
    msg: "test",
    status: false
  });

  //for filter
  function getProductCategory() {
    fetch(environment.baseUrl + "getProductCategory?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    })
      .then((apiRes) => {
        apiRes.json().then((resp) => {
          //console.log("Category:", resp)
          if (resp.code == 200) {
            setCate(resp.data.result.categories);
            //getFuelTable(resp.data.result.categories);
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            setCate([]);
          }
        })
      })
  }
  function getProductSubCategory(pid) {
    fetch(environment.baseUrl + "getProductSubCategory?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          "parentID": pid
        })
    }).then((result) => {
      result.json().then(res => {
        //console.log("SubCategory:", res.data.result.subCategories);
        if (res.code == 200) {
          setSubCate(res.data.result.subCategories);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setSubCate([]);
        }
      })
    })
  }

  function getDropDown() {
    fetch(environment.baseUrl + "getDropDown", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "groupName": ["equipmentType"],
        "masterType": ["asset"]
      })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setDropDownData(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setDropDownData({
            asset_equipmentType: [
              { name: "" },
            ]
          })
        }
      })
    })
  }
  function getSiteList() {
    fetch(environment.baseUrl + "getSiteByUserAccount", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        //console.log("getsite:", resp)
        if (resp.code == 200) {
          setSiteList(resp.data.result.siteList);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setSiteList([]);
        }
      })
    })
  }
  function getAssetList() {
    fetch(environment.baseUrl + "getEquipmentsByUser", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((result) => {
      result.json().then((res) => {
        //console.log(res);
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }

  function getEquipmentBySite(sid) {
    fetch(environment.baseUrl + "getEquipmentBySite?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify(
        {
          siteID: sid
        })
    }).then((result) => {
      result.json().then(res => {
        if (res.code == 200) {
          setAllAsset(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setAllAsset([]);
        }
      })
    })
  }
  //for filter

  function saveFormData() {

    fetch(environment.baseUrl + "createOperatorAssetMapping?", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        accountID: userObj.accountID,
        operatorName: operator.operatorName,
        licenceID: operator.licenceID,
        licenceExpiryDate: operator.licenceExpiryDate,
        licenceValdity: operator.licenceValdity,
        //isActive: operator.isActive,
        assetID: operator.assetID,
        shiftID: operator.shiftID
      })
    }).then((result) => {
      result.json().then((res) => {
        setAlert({
          msg: res.msg,
          status: true
        })
        if (res.code == 200) {
          ResetForm();
          getOperatorByAcc();
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
      })
    })
  }

  let [operatorList, setOperatorList] = useState([]);

  let [OperatorByAcc, setOperatorByAcc] = useState([]);
  function getOperatorByAcc() {
    fetch(environment.baseUrl + "getOperatorByAccount?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setOperatorByAcc(resp.data.result);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setOperatorByAcc([]);
        }
      })
    })
  }
  let [operatorData, setoperatorData] = useState([]);
  let [headerData, setheaderData] = useState([]);


  let dateTo = moment().format('YYYY-MM-DD 23:59:59')
  function getoperatorImpactData(obj) {
    fetch(environment.baseUrl + "operatorDashboardImpactReport", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({

        dateFrom: obj.fromDate != "" ? obj.fromDate + " 00:00:00" : "",
        dateTo: obj.toDate != "" ? obj.toDate + " 23:59:59" : "",
        month: obj.month,
        Year: obj.year,
        equipmentID: obj.equipmentID,
        equipmentType: obj.equipmentType,
        siteID: obj.siteID,
        productCategoryID: obj.productCategoryID,
        productSubCategoryID: obj.productSubCategoryID
      })
    }).then((result) => {
      //alert("API call Succesfully");
      result.json().then(res => {
        setFilterShow(false);
        if (res.code == 200) {
          setheaderData(res.data.headerLabels);
          setoperatorData(res.data.OperatorImpactList);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setheaderData([]);
          setoperatorData([]);
        }
      })
    })
  }
  let [equipmentByUser, setequipmentByUser] = useState([]);
  function getEquipmentByUser() {
    fetch(environment.baseUrl + "getEquipmentsByUser?", {
      method: "GET",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      }

    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setequipmentByUser(resp.data.result);
          setAllAsset(resp.data.result)
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setequipmentByUser([]);
          setAllAsset([]);
        }
      })
    })
  }
  function showOpeShifts(operatorID, assetId) {
    setOpeShiftData([]);
    getShiftByOperatorID(operatorID, assetId);
    setShowOpeShift(true);
  }
  const handleClose3 = () => {
    setOpSelect([]);
    setOpApishift([]);
    setShowOpeShift(false);
  }
  let [showOpeShift, setShowOpeShift] = useState(false);
  let [opeShiftData, setOpeShiftData] = useState([]);
  function getShiftByOperatorID(opeId, assetId) {
    fetch(environment.baseUrl + "getShiftByOperatorID", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        operatorID: opeId,
        assetID: assetId
      })
    }).then((apiRes) => {
      apiRes.json().then((resp) => {
        if (resp.code == 200) {
          setOpeShiftData(resp.data.result);
          let shiftObj = [], apArr = [];
          resp.data.result.forEach(element => {
            apArr.push(element.shiftID);
            shiftObj.push({ label: element.shiftName, value: element.shiftID })
          });
          //console.log(shiftObj)
          setOpSelect(shiftObj);
          setOpApishift(apArr);
        }
        else if (resp.code == 401) {
          setSessOut(true);
        }
        else {
          setOpeShiftData([]);
        }
      })
    });
  }
  let [opApishift, setOpApishift] = useState([]);
  let [operatorShift, setOperatorShift] = useState([]);
  function getShiftForOpoerator() {
    fetch(environment.baseUrl + "getShiftBySite", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        "accountID": userObj.accountID
      })
    }).then((result) => {
      result.json().then((res) => {
        if (res.code == 200) {
          setOperatorShift(res.data.result);
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setOperatorShift([]);
        }

      })
    })
  }
  let [totalImpact, settotalImpact] = useState([]);
  let [highImpact, sethighImpact] = useState([]);
  function getTotalOperatorImpacts(id, name) {
    fetch(environment.baseUrl + "totalOperatorImpacts", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        operatorID: id,
        name: name,
        dateFrom: filter.fromDate != "" ? filter.fromDate + " 00:00:00" : "",
        dateTo: filter.toDate != "" ? filter.toDate + " 23:59:59" : "",
        month: filter.month,
        Year: filter.year,
        equipmentID: filter.equipmentID,
        equipmentType: filter.equipmentType,
        siteID: filter.siteID,
        productCategoryID: filter.productCategory,
        productSubCategoryID: filter.productSubCategory
      })
    })
      .then((apiRes) => {
        apiRes.json().then(resp => {
          if (resp.code == 200) {
            settotalImpact(resp.data.totalOperatorImpacts);
            imapactHandle();
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            settotalImpact([]);
            alert(resp.msg);
          }
        })

      })

  }
  function getHighOperatorImpacts(id, name) {
    fetch(environment.baseUrl + "highOperatorImpacts", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        operatorID: id,
        name: name,
        dateFrom: filter.fromDate != "" ? filter.fromDate + " 00:00:00" : "",
        dateTo: filter.toDate != "" ? filter.toDate + " 23:59:59" : "",
        month: filter.month,
        Year: filter.year,
        equipmentID: filter.equipmentID,
        equipmentType: filter.equipmentType,
        siteID: filter.siteID,
        productCategoryID: filter.productCategory,
        productSubCategoryID: filter.productSubCategory
      })
    })
      .then((apiRes) => {
        apiRes.json().then(resp => {
          if (resp.code == 200) {
            sethighImpact(resp.data.highOperatorImpacts);
            criticalHandle();
          }
          else if (resp.code == 401) {
            setSessOut(true);
          }
          else {
            sethighImpact([]);
            alert(resp.msg);
          }
        })

      })
  }
  let [shiftBlank, setShiftBlank] = useState(false);
  let [operatorShift1, setOperatorShift1] = useState([]);
  function getShiftByEquipment(assetID, siteID) {
    setOperatorShift1([]);
    fetch(environment.baseUrl + "getExcludedShiftBySite", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        assetID: assetID,
        siteID: siteID,
        accountID: userObj.accountID
      })
    }).then((apiRes) => {
      apiRes.json().then((res) => {
        //console.log("getShiftByEquipment:", res)
        if (res.code == 200) {
          if (res.data.result.length === 0) {
            setOperatorShift1([]);
            setShiftBlank(true);
          }
          else {
            setOperatorShift1(res.data.result)
            setShiftBlank(false);
          }
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
        else {
          setOperatorShift1([]);
        }
      })
    })
  }
  let [opSelect, setOpSelect] = useState([]);
  function checkOpSelect(val) {
    if (val.length <= 3) {
      setOpSelect(val)
    }
  }
  useEffect(() => {
    let arr = [];
    opSelect.map(e => (arr.push(e.value)));
    setOperator({ ...operator, shiftID: arr });
  }, [opSelect])
  function getOperatorFormData(e) {
    if (e.target.name == "assetID") {
      setOperator({ ...operator, [e.target.name]: e.target.value });
      setOpSelect([]);
      setOperatorShift1([]);
      setOpeShiftData([]);
      let sid = equipmentByUser[e.target.selectedIndex - 1].siteID
      getShiftByEquipment(e.target.value, sid)
    }
    if (e.target.name == "licenceValdity") {
      setOperator({ ...operator, [e.target.name]: e.target.value, licenceExpiryDate: e.target.value });

    }
    else {
      setOperator({ ...operator, [e.target.name]: e.target.value });
    }
  }
  let [operatorErrorMsg, setOperatorErrorMsg] = useState({});
  function ValidateFormData() {
    let errror = {};
    if (operator.operatorName == "") {
      errror.operatorName = "This field is required";//Select Acoount"
    }
    if (operator.operatorName.length > 25) {
      errror.operatorName = "Exceeded 25 characters limit";//Select Acoount"
    }
    if (operator.assetID == "") {
      errror.assetID = "This field is required";//Select Acoount"
    }
    if (operator.licenceExpiryDate == "") {
      errror.licenceExpiryDate = "This field is required";//Select Acoount"
    }

    if (operator.licenceID == "") {
      errror.licenceID = "This field is required";//Select Acoount"
    }
    if (operator.licenceID.length > 25) {
      errror.licenceID = "Exceeded 25 characters limit";//Select Acoount"
    }
    if (operator.shiftID.length == 0) {
      errror.shiftID = "This field is required";//Select Acoount"
    }
    // console.log("error", errror);
    setOperatorErrorMsg(errror);
    if (Object.keys(errror).length == 0) {
      saveFormData();
    }
  }
  let [operatorErrorMsg1, setOperatorErrorMsg1] = useState({});
  function ValidateUpdateFormData() {
    let errror = {};
    if (operator.assetID == "") {
      errror.assetID = "This field is required";//Select Acoount"
    }
    if (operator.shiftID.length == 0) {
      errror.shiftID = "This field is required";//Select Acoount"
    }
    setOperatorErrorMsg1(errror);
    if (Object.keys(errror).length == 0) {
      updateOperatorData();
    }
  }
  
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setOperatorErrorMsg1({})
    ResetForm()
    setOpSelect([]);
    setOpApishift([]);
    setShow(false);
  }

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);

  function imapactHandle() {
    setShow1(true);
  }
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);

  function criticalHandle() {
    setShow2(true);
  }
  function editOperatorData(curretOp) {
    //console.log("edit",curretOp);
    let siteId = null;
    for (let index = 0; index < equipmentByUser.length; index++) {
      if (equipmentByUser[index].assetID === curretOp.assetID) {
        siteId = equipmentByUser[index].siteID;
        break;
      }
    }
    getShiftByOperatorID(curretOp.operatorID, curretOp.assetID);
    getShiftByEquipment(curretOp.assetID, siteId);
    setOperator({
      ...operator,
      operatorName: curretOp.operatorName,
      licenceID: curretOp.licenceID,
      licenceExpiryDate: (curretOp.licenceExpiryDate).slice(0, 10),
      licenceValdity: curretOp.licenceValdity,
      isActive: true,
      opeType: "edit",
      operatorID: curretOp.operatorID,
      assetID: curretOp.assetID,
    });
    setShow(true);
  }
  function setAddRemoveShifts() {
    let removeItem = opApishift.filter((o) => operator.shiftID.indexOf(o) === -1);
    let addItem = operator.shiftID.filter((o) => opApishift.indexOf(o) === -1);
    return (
      {
        removeItem: removeItem,
        addItem: addItem
      }
    )
  }
  function updateOperatorData() {
    let obj = setAddRemoveShifts();
    fetch(environment.baseUrl + "updateOperatorAssetMapping?", {
      method: "PUT",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userObj.token
      },
      body: JSON.stringify({
        operatorID: operator.operatorID,
        accountID: userObj.accountID,

        operatorName: operator.operatorName,
        licenceID: operator.licenceID,
        licenceExpiryDate: operator.licenceExpiryDate,
        //licenceValdity: operator.licenceValdity,
        isActive: operator.isActive,
        assetID: operator.assetID,
        removeShiftID: obj.removeItem,
        addShiftID: obj.addItem
      })
    }).then((result) => {
      result.json().then((res) => {
        handleClose();
        setAlert({
          msg: res.msg,
          status: true
        });
        if (res.code == 200) {
          getOperatorByAcc();
        }
        else if (res.code == 401) {
          setSessOut(true);
        }
      })
    })
  }
 
  ///////////////////////////////////////
  const columns = useMemo(
    () => [
      {
        Header: 'Operator Name ',
        accessor: 'operatorName', // accessor is the "key" in the data
      },
      {
        Header: 'Equipment Mapped',
        accessor: 'assetID',
      },
      {
        Header: 'License Validity Date ',
        accessor: 'licenceExpiryDate',
      },
      {
        Header: 'License Validity',
        accessor: 'validityStatus',
      },
      {
        Header: 'License Number',
        accessor: 'licenceID',
      },
      {
        Header: 'View',
        accessor: 'view',
      },
      {
        Header: 'Action',
        accessor: 'action',
      },
    ],
    []
  )

  const columns1 = useMemo(
    () => [
      {
        Header: 'Equipment ',
        accessor: 'assetID', // accessor is the "key" in the data
      },
      {
        Header: 'G-Force value',
        accessor: 'gForce',

      },
      {
        Header: 'Impact Date and Time',
        accessor: 'ist',

      },


    ],
    []
  )

  const Table_columns = useMemo(
    () => [
      {
        Header: 'Name ',
        accessor: 'name', // accessor is the "key" in the data
      },
      {
        Header: 'Total Impact Counter',
        accessor: 'totalImpactCounter',
      },
      {
        Header: 'Critical Impact Counter',
        accessor: 'highImpactCounter',
      },


    ],
    []
  )
  function checkDurFilter(filObj) {
    if (filObj.fromDate != "" || filObj.toDate != "" || filObj.year != "" || filObj.month != "") {
      return true;
    }
    else {
      return false
    }
  }
  function saveGlobelFilter() {
    sessionStorage.setItem("GloberFilter", JSON.stringify({
      equipmentID: filter.equipmentID ? filter.equipmentID : "",
      equipmentType: filter.equipmentType ? filter.equipmentType : "",
      siteID: filter.siteID ? filter.siteID : "",
      fromDate: filter.fromDate ? filter.fromDate : "",
      toDate: filter.toDate ? filter.toDate : "",
      month: filter.month ? filter.month : "",
      year: filter.year ? filter.year : "",
      productCategoryID: filter.productCategoryID ? filter.productCategoryID : "",
      productSubCategoryID: filter.productSubCategoryID ? filter.productSubCategoryID : "",
    }));
    getoperatorImpactData(filter);
  }
  return (
    <div className='main-container'>
      <SessionFun show={sessOut}></SessionFun>
      <Alert obj={malert} />
      <h4 className='main-heading'>Operator Dashboard</h4>
      <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; Operator Dashboard</p>
      <div className="row">
        <Tabs className='tab-menu' defaultActiveKey="first" id="">
          <Tab eventKey="first" title="Add Operator">
            <div className="mt-3 card-box-block">

              <h6 className='cardtitle'>Add New Operator</h6>
              <div className='row'>
                <div className='col-sm-4 left-col'>
                  <Form.Group className="mb-2" >
                    <label>Operator Name</label><span className='red'>*</span>
                    <Form.Control type='text' placeholder='Operator name' name='operatorName' className="textbox-back"
                      onChange={getOperatorFormData} value={operator.operatorName} />
                    <small className='red'>{operatorErrorMsg.operatorName}</small>
                  </Form.Group>
                </div>
                <div className='col-sm-4'>
                  <Form.Group className="mb-2" >
                    <Form.Label>Equipment</Form.Label><span className='red'>*</span>
                    <Form.Select as='select' name='assetID'
                      onChange={getOperatorFormData} className="textbox-back" value={operator.assetID}>
                      <option value="">Select Equipment</option>
                      {
                        equipmentByUser.map((item, index) =>
                          <option key={index} value={item.assetID}>{item.assetID}</option>
                        )
                      }
                    </Form.Select>
                    <small className='red'>{operatorErrorMsg.assetID}</small>
                  </Form.Group>
                </div>
                <div className="col-sm-4">
                  <Form.Group className="mb-2" >
                    <Form.Label>Shifts<span className='red'>*</span>
                      {
                        shiftBlank ? <small className='red'>&nbsp;(Shifts are already allocated)</small> : ""
                      }
                    </Form.Label>
                    <MultiSelect
                      options={operatorShift1.map(e => ({ label: e.shiftName, value: e.shiftID }))}
                      value={opSelect}
                      onChange={checkOpSelect}
                      labelledBy="Select Shifts"
                      valueRenderer={valueRenderer}
                    />
                    <small className='red'>{operatorErrorMsg.shiftID}</small>
                    <small className='red' style={{ float: "right" }}>Max 3 Shifts allowed*</small>

                  </Form.Group>
                </div>
                <div className='col-sm-4 left-col'>
                  <Form.Group className="mb-2" >
                    <Form.Label>License Validity(Date)</Form.Label><span className='red'>*</span>
                    <Form.Control type='date' min={moment().format('YYYY-MM-DD')} placeholder='License Number' name='licenceExpiryDate'
                      className="textbox-back" onChange={getOperatorFormData} value={operator.licenceExpiryDate} />
                    <small className='red'>{operatorErrorMsg.licenceExpiryDate}</small>
                  </Form.Group>
                </div>
                <div className='col-sm-4 '>
                  <Form.Group className="mb-2" >
                    <label>Operator License Number</label><span className='red'>*</span>
                    <Form.Control type='text' placeholder='License Number' name='licenceID'
                      onChange={getFormData} className="textbox-back" value={operator.licenceID} />
                    <small className='red'>{operatorErrorMsg.licenceID}</small>
                  </Form.Group>
                </div>
              </div>
              <div className="row mt-3 justify-content-end">
                <button type='cancel' className="btn btn-outline-secondary lo-btn me-3" onClick={ResetForm}>
                  Clear
                </button>
                <button type='submit' className="btn btn-primary add-btn" onClick={ValidateFormData}>
                  Add
                </button>
              </div>

            </div>
          </Tab>
          <Tab eventKey="second" title="Operator License Details">
            <div className="row card-box-block mt-3">
              <div className="col-sm-12">
                <h6 className='cardtitle'>Operator License Details</h6>
                <Table columns={columns} data={OperatorByAcc} editOp={editOperatorData} showShifts={showOpeShifts} />
              </div>
            </div>
          </Tab>
          <Tab eventKey="third" title="Operator Impact">
            <div className={dashboard.indexOf(701) == -1 ? "d-none" : "row card-box-block mt-3"}>
              <div className="col-sm-12">
                <div className="row">
                  <div className="col-sm-10 left-col">
                    <h6 className='cardtitle'>Operator Impact</h6>
                  </div>
                  <div className="col-sm-2  text-end">
                    <FontAwesomeIcon icon={faBars} onClick={() => setFilterShow(true)} />
                  </div>
                </div>
                <hr />
                <Table columns={Table_columns} data={operatorData} totalOpImp={getTotalOperatorImpacts} highOpTemp={getHighOperatorImpacts} />
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
      <Modal show={showOpeShift} onHide={handleClose3} centered backdrop="static" >
        <Modal.Header>
          <Modal.Title> Shifts</Modal.Title>
          <button onClick={handleClose3} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <table className="table">
            <thead className='table-secondary'>
              <tr>
                <th >Shifts</th>
              </tr>
            </thead>
            <tbody>
              {
                opeShiftData.map((item, index) =>
                  <tr key={index}>
                    <td>{item.shiftName}</td>
                  </tr>
                )
              }
            </tbody>
          </table>

          <div className="row justify-content-end mt-3">
            <button className="btn btn-outline-secondary lo-btn float-end"
              onClick={handleClose3}>
              Cancel
            </button>
          </div>

        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title> Edit Operator</Modal.Title>
          <button onClick={handleClose} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          <div className='row'>
            <div className='col-sm-4 left-col'>
              <Form.Group className="mb-2" >
                <Form.Label>Operator Name</Form.Label>
                <Form.Control type='text' placeholder='Operator name' name='operatorName' className="textbox-back"
                  value={operator.operatorName} onChange={getOperatorFormData} readOnly />
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <Form.Label>Equipment Mapped (current)</Form.Label>
                {/* <Form.Control type='text' placeholder='Equipment Mapped (current)' name='assetID' className="textbox-back"
                  value={operator.assetID} onChange={getOperatorFormData} readOnly /> */}
                <Form.Select as='select' name='assetID'
                  onChange={getOperatorFormData} className="textbox-back" value={operator.assetID}>
                  <option value="">Select Equipment</option>
                  {
                    equipmentByUser.map((item, index) =>
                      <option key={index} value={item.assetID}>{item.assetID}</option>
                    )
                  }
                </Form.Select>
                <small className='red'>{operatorErrorMsg1.assetID}</small>
              </Form.Group>
            </div>
            <div className="col-sm-4">
              <Form.Group className="mb-2" >
                <Form.Label>Shifts</Form.Label>
                <MultiSelect
                  options={(operatorShift1.concat(opeShiftData)).map(e => ({ label: e.shiftName, value: e.shiftID }))}
                  value={opSelect}
                  onChange={checkOpSelect}
                  labelledBy="Select"
                  valueRenderer={valueRenderer}
                />
                <small className='red'>Max 3 Shifts allowed*</small>
                <small className='red'>&nbsp;{operatorErrorMsg1.shiftID ? "," + operatorErrorMsg1.shiftID : null}</small>
              </Form.Group>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-4 left-col'>
              <Form.Group className="mb-2 " >
                <Form.Label>License Validity Date</Form.Label>
                <Form.Control type='date' placeholder='	License Validity Date' name='licenceExpiryDate'
                  className="textbox-back" value={operator.licenceExpiryDate} onChange={getOperatorFormData}/>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
              <Form.Label>License Number</Form.Label>
                <Form.Control type='text' placeholder='License Number' name='licenceID'
                  value={operator.licenceID} className="textbox-back" onChange={getOperatorFormData} readOnly >
                </Form.Control>

              </Form.Group>
            </div>

          </div>

          <div className="row text-center mt-4">
            <div className="col-sm-6">
              <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose}>
                Cancel
              </button>
            </div>
            <div className="col-sm-6">
              <button className="btn btn-light lo-btn confirm-btn float-start" onClick={ValidateUpdateFormData} >
                Update
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={show1} onHide={handleClose1} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>Total Impacts</Modal.Title>
          <button onClick={handleClose1} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          {
            totalImpact.length ?
              <Table columns={columns1} data={totalImpact} /> :
              <p className='text-center'><b>No data available</b></p>
          }

        </Modal.Body>
      </Modal>
      <Modal show={show2} onHide={handleClose2} centered backdrop="static" size="lg">
        <Modal.Header>
          <Modal.Title>Critical Impacts</Modal.Title>
          <button onClick={handleClose2} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className=' logout-box'>
          {
            highImpact.length ?
              <Table columns={columns1} data={highImpact} /> :
              <p className='text-center'><b>No data available</b></p>
          }
        </Modal.Body>
      </Modal>

      {/* for dashboard filter */}
      <Modal show={filterShow} onHide={() => setFilterShow(false)} centered backdrop="static" size='lg'>
        <Modal.Header>
          <Modal.Title> Filter </Modal.Title>
          <button onClick={() => setFilterShow(false)} type="button" className="close">
            <img src={close} alt="" />
          </button>
        </Modal.Header>
        <Modal.Body className='logout-box'>
          <div className="row">
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <Form.Label>From Date</Form.Label>
                <Form.Control type='date' name='fromDate' value={filter.fromDate}
                  className="textbox-back" onChange={getFilterData} />
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <Form.Label>To Date</Form.Label>
                <Form.Control type='date' name='toDate' value={filter.toDate} min={filter.fromDate}
                  className="textbox-back" onChange={getFilterData} />
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <Form.Label>Month</Form.Label>
                <Form.Control type='month' name='month' value={filter.month}
                  className="textbox-back" onChange={getFilterData} />
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2 " >
                <Form.Label>Year</Form.Label>
                <Form.Select as='select' placeholder='year' name='year' value={filter.year}
                  className="textbox-back" onChange={getFilterData}>
                  <option value="">Select Year</option>
                  {
                    years.map((item, index) =>
                      <option key={index} value={item}>{item}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Category</label>
                <Form.Select as='select' name='productCategoryID' className="textbox-back" value={filter.productCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    cate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Product Sub Category</label>
                <Form.Select as='select' name='productSubCategoryID' className="textbox-back" value={filter.productSubCategoryID} onChange={getFilterData}>
                  <option value="">Select Category</option>
                  {
                    subCate.map((item, index) =>
                      <option key={index} value={item.categoryID}>{item.categoryName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Site</label>
                <Form.Select as='select' name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                  <option value="">Select Site</option>
                  {
                    siteList.map((item, index) =>
                      <option key={index} value={item.siteID}>{item.siteName}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4'>
              <Form.Group className="mb-2" >
                <label>Equipment ID</label>
                <Form.Select as='select' name='equipmentID' className="textbox-back" value={filter.equipmentID} onChange={getFilterData}>
                  <option value="">Select Equipment ID</option>
                  {
                    allAseet.map((item, index) =>
                      <option key={index} value={item.assetID}>{item.assetID}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
            <div className='col-sm-4 '>
              <Form.Group className="mb-2" >
                <label>Equipment Type</label>
                <Form.Select as='select' name='equipmentType' className="textbox-back" value={filter.equipmentType} onChange={getFilterData}>
                  <option value="">Select Equipment Type</option>
                  {
                    (dropdownData.asset_equipmentType).map((item, index) =>
                      <option key={index} value={item.name}>{item.name}</option>
                    )
                  }
                </Form.Select>
              </Form.Group>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <button className="btn btn-outline-secondary lo-btn" onClick={resetFilter}>
              Reset
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn mx-3" onClick={getFilterFields}>
              Apply
            </button>
            <button className="add-btn btn-light lo-btn confirm-btn" onClick={saveGlobelFilter}>
              Apply All
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* for dashboard filter */}
    </div>
  )
}

export default Operator
